import { createMuiTheme } from '@material-ui/core/styles';
export const theme = createMuiTheme({
	palette: {
		primary: {
			light: '#ffffff',
			main: '#fafafa',
			dark: '#c7c7c7',
			contrastText: '#fff'
		},
		secondary: {
			light: '#9be7ff',
			main: '#64b5f6',
			dark: '#2286c3',
			contrastText: '#000'
		}
	}
});